import Vue from 'vue';
import agreement from './index.vue';

let instance = null;

const AgreementCtor = Vue.extend(agreement);

const AgreementModal = function ({ data, props }) {
  if (!instance) {
    instance = new AgreementCtor();
    instance.$mount();
    document.body.appendChild(instance.$el);
  }
  Object.assign(instance.$data, data);
  Object.assign(instance.$props, props);
  return instance;
};

AgreementModal.show = data => AgreementModal(data).show();

export default AgreementModal;
